export default "__VITE_ASSET__DI$J5x1g__"